// NotFound - 404 error page
// Implements US-0.2: Frontend Design System

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import styles from './NotFound.module.css';

/**
 * RENDER 404 Not Found error page
 * NOTE: Provides helpful navigation back to main app areas
 */
const NotFound: React.FC = () => {
  const navigate = useNavigate();

  /**
   * HANDLE go back action
   * NOTE: Uses browser history to return to previous page
   */
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Layout>
      <div className={styles.content}>
        {/* ERROR code */}
        <div className={styles.errorCode}>404</div>

        {/* TITLE */}
        <h1 className={styles.title}>Seite nicht gefunden</h1>

        {/* MESSAGE */}
        <p className={styles.message}>
          Entschuldigung, wir konnten die gesuchte Seite nicht finden. Sie wurde möglicherweise verschoben,
          gelöscht oder die URL ist falsch.
        </p>

        {/* NAVIGATION actions */}
        <div className={styles.actions}>
          <Link to="/workspaces" className={styles.button}>
            Zu meinen Workspaces
          </Link>
          <Link to="/guest" className={`${styles.button} ${styles.buttonSecondary}`}>
            Als Gast beitreten
          </Link>
          <button
            onClick={handleGoBack}
            className={`${styles.button} ${styles.buttonSecondary}`}
          >
            Zurück
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
